import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Eritrean() {
  return (
    <ApiCommunityDirectoryPage
      community="Eritrean"
      eyebrow="Eritrean community guide"
      title="Eritrean favorites, businesses, and local essentials in San Antonio."
      
      tags={["Eritrean community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Eritrean community guide?"
      modalIdPrefix="eritrean-directory"
    />
  );
}
